import Modal from "react-native-modal";
import { StyleSheet, View, Button, Text, Image, TextInput, ScrollView } from 'react-native'; //Modal
import FontAwesome from "@expo/vector-icons/FontAwesome";
import { useState, useEffect } from 'react';
import Chip from '@mui/material/Chip';
// import { db } from '../firebaseConfig';
// import { doc, getDoc } from 'firebase/firestore';

import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Configure, SearchBox, Hits, RefinementList, CurrentRefinements } from 'react-instantsearch';
// import 'instantsearch.css/themes/satellite.css';
import './SearchFilterModal.css';

// TODO: perhaps delete this component and use the one from react-native-modal
export default function SearchFilterModal({ message, visible, dismiss, barFilter, tagFilter, postTypeFilter }) {

  const [barNameSearch, setBarNameSearch] = useState('');
  const [tagSearch, setTagSearch] = useState('');
  const searchClient = algoliasearch('LQ3F0F4NOD', '4c4674bab09f222ab5b74826b756e45d');

  // console.log("postTypeFilter:", postTypeFilter);

  useEffect(() => {
    (async () => {
      if(barFilter) {
        setBarNameSearch(barFilter);
      }
      else
      {
        setBarNameSearch('');
      }
      if(tagFilter) {
        setTagSearch(tagFilter);
      }
      else
      {
        setTagSearch('');
      }
    })();
  }, [barFilter, tagFilter])

  const setBarNameSearchFunc = async (newValue) => {
    setBarNameSearch(newValue);
    setTagSearch('');
  }

  const setTagSearchFunc = async (newValue) => {
    setBarNameSearch('');
    setTagSearch(newValue);
  }

  function Hit({ hit }) {
    // console.log("hit:", hit);
    return (
      <View style={styles.hitContainer}>
        {hit.bar && (
          <View style={styles.hitRow}>
            <Text style={styles.hitLabel}>bar: </Text>
            <Text style={styles.hitValue} onClick={() => dismiss(hit.bar, '', '')}>
              {hit.bar}
            </Text>
          </View>
        )}
        {hit.username && (
          <View style={styles.hitRow}>
            <Text style={styles.hitLabel}>username: </Text>
            <Text style={styles.hitValue} onClick={() => dismiss('', '', hit.username)}>
              {hit.username}
            </Text>
          </View>
        )}
        {hit.tagsArray && hit.tagsArray != null && hit.tagsArray.length > 0 && 
          hit.tagsArray.map(tag => (
            <View style={styles.hitRow} key={tag + 'view'}>
              <Text style={styles.hitLabel} key={tag + 'label'}>tag: </Text>
              <Text key={tag} style={styles.hitValue} onClick={() => dismiss('', tag, '')}>
                {tag}
              </Text>
            </View>
          ))
        }
      </View>
    );
  }

  // const deleteDuplicates = (items) =>
  // items
  //   .map(item => {
  //     // make a temporary key for deduplication
  //     item.__dedupe = `${item.index}.${item.id}`;
  //     return item;
  //   })
  //   .filter(
  //     (obj, pos, arr) =>
  //       arr.map(item => item.__dedupe).indexOf(obj.__dedupe) === pos
  //   )
  //   .map(item => {
  //     // delete it afterwards
  //     delete item.__dedupe;
  //     return item;
  //   });
  
  return (
    <Modal
      isVisible={visible}
      hasBackdrop={true}
      backdropColor="#EBBB40"
      backdropOpacity={0.6}
      onBackdropPress={() => dismiss(0)}
      //style={{ width: 200, minHeight: 200 }}
      // transparent={transparent}
      // onRequestClose={dismiss}
    >
      {/* <TouchableWithoutFeedback onPress={dismiss}>
        <View style={styles.modalOverlay} />
      </TouchableWithoutFeedback> */}

      <View style={styles.modalContainer}>
        <View style={styles.modalContent}>

          <Text style={styles.modalTitle}>Search Posts</Text>
          <Text style={styles.modalSubtitle}>Find by bar name, tag, or username</Text>
          {/* <TextInput
            style={{ height: 40, width: '100%', backgroundColor: '#f0f0f0', padding: 5, marginTop: 5, marginBottom: 10 }}
            placeholder="enter bar name"
            placeholderTextColor="gray"
            onChangeText={newText => setBarNameSearchFunc(newText)}
            defaultValue={barNameSearch}
            textAlignVertical={"center"}
            maxLength={40}
          />

          <Text style={{ fontSize: 18, width: '100%', textAlign: 'center', fontWeight: 'bold' }}>or</Text>

          <Text style={{ fontSize: 18 }}>Search by tag:</Text>
          <TextInput
            style={{ height: 40, width: '100%', backgroundColor: '#f0f0f0', padding: 5, marginTop: 5, marginBottom: 20 }}
            placeholder="enter tag"
            placeholderTextColor="gray"
            onChangeText={newText => setTagSearchFunc(newText.toLowerCase())}
            defaultValue={tagSearch}
            textAlignVertical={"center"}
            maxLength={40}
          />

          <Button
            style={{ marginTop: 50 }}
            onPress={() => dismiss(barNameSearch, tagSearch)}
            title="Search"
            color="#0D4DF2"
          /> */}

          <InstantSearch searchClient={searchClient} indexName="barswim_posts">
            <Configure
              hitsPerPage={7}
              distinct={true}
              attributesToRetrieve={[
                "bar",
                "username",
                "tagsArray",
                "postType",
              ]}
              restrictSearchableAttributes={[
                "bar",
                "username",
                "tagsArray",
              ]}
              filters={postTypeFilter ? `postType:${postTypeFilter}` : undefined} />
            <View style={styles.searchBoxContainer}>
              <SearchBox placeholder="search posts" />
            </View>
            <ScrollView style={styles.hitsContainer}>
              <Hits 
                hitComponent={Hit}
                classNames={{
                  root: 'hits-root',
                  list: 'hits-list',
                  item: 'hits-item'
                }}
              />
            </ScrollView>
            {/* <CurrentRefinements transformItems={deleteDuplicates}/> */}
          </InstantSearch>

        </View>
      </View>
    </Modal>
  );
}

 
const styles = StyleSheet.create({ 
  buttonLabel: {
    color: '#fff',
    fontSize: 16,
  },
  userImage2: {
    width: '100%',
    height: 200,
    //borderRadius: 40/2,
    //marginRight: 5,
  },
  filter: {
    alignSelf: 'center',
    color: '#fff',
    backgroundColor: "#0D4DF2",
    marginTop: 30,
  },
  modalContainer: {
    width: 340,
    maxHeight: 550,
    backgroundColor: 'white',
    alignSelf: 'center',
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 8,
  },
  modalContent: {
    flex: 1,
    flexDirection: 'column',
    padding: 16,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 4,
  },
  modalSubtitle: {
    fontSize: 13,
    color: '#666',
    marginBottom: 16,
  },
  searchBoxContainer: {
    marginBottom: 12,
  },
  hitsContainer: {
    flex: 1,
    overflow: 'auto',
  },
  hitContainer: {
    padding: 10,
    marginVertical: 4,
    backgroundColor: '#f9f9f9',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#e0e0e0',
  },
  hitRow: {
    flexDirection: 'row',
    marginVertical: 2,
    flexWrap: 'wrap',
  },
  hitLabel: {
    fontSize: 12,
    color: '#666',
    fontWeight: '600',
    marginRight: 4,
  },
  hitValue: {
    fontSize: 14,
    color: '#674FE0',
    fontWeight: '500',
    textDecorationLine: 'underline',
    cursor: 'pointer',
  },
  // modalBackdrop: {
  //   position: fixed;
  //   top: 0;
  //   bottom: 0;
  //   left: 0;
  //   right: 0;
  //   background-color: rgba(0, 0, 0, 0.4);
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   z-index: 2;
  // }
  
  // .modal-content {
  //   width: 60%;
  //   min-height: 200px;
  //   background-color: white;
  //   padding: 25px;
  // }
  
});
